"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Column = exports.ResponsiveColumn = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _ResponsiveCell = require("./ResponsiveCell");

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

/**
 * Column section of a `<ResponsiveGrid>`. Should always be the immediate child
 * of a `<ResponsiveRow>`.
 */
var ResponsiveColumn = function ResponsiveColumn(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveCell.ResponsiveCell, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    className: (0, _react.css)('ms-ResponsiveGrid--column', className),
    direction: 'column'
  }, props), {}, {
    children: children
  }));
};

exports.Column = exports.ResponsiveColumn = ResponsiveColumn;

_ResponsiveGridMarkers.ResponsiveGridCellMarker.mark(ResponsiveColumn);